import BibliographyBasicSearchCollection, {
  InputBasicSearchCollectionItem,
  defaultInputBasicSearchCollectionItem
} from './BibliographyBasicSearchCollection.vue'

export {
  BibliographyBasicSearchCollection,
  InputBasicSearchCollectionItem,
  defaultInputBasicSearchCollectionItem
}
